import { Outlet } from "react-router-dom";

export default function CurrentProjects() {
    return (
       <div>
            <Outlet/>
       </div>
    )
}
